export default {
  presets: {
    light: {
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
    /** Tema corporativo (color dorado #b59537) */
    mausoleo: {
      primary: '#b59537',
      secondary: '#767C88',
      success: '#3D9209',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
      backgroundPrimary: '#f6f6f6',
      backgroundSecondary: '#FFFFFF',
      backgroundElement: '#ECF0F1',
      backgroundBorder: '#DEE5F2',
      textPrimary: '#262824',
      textInverted: '#FFFFFF',
      shadow: 'rgba(0, 0, 0, 0.12)',
      focus: '#c9a84d',
      transparent: 'rgba(0, 0, 0, 0)',
    },
  },
}
